<style lang="less" scoped>
.subject-infor {
    .common-item {
      // display: flex;
      margin: 10px 0;
      .label {
        display: inline-block;
        width: 200px;
        text-align: right;
      }
      .value {
        display: inline-block;
       // flex: 1;
      }
    }
}
</style>
<template>
  <div class="subject-infor">
    <p class="common-item">
      <span class="label">公司：</span>
      <span class="value">{{ subjectInforDetial.company_name }}</span>
    </p>
    <p class="common-item">
      <span class="label">状态：</span>
      <span
        class="value"
        :style="{
          'font-weight':'bold',
          color:subjectInforDetial.has_frozen?WARNING:SUCCESS
        }"
      >{{ subjectInforDetial.has_frozen===undefined?'': subjectInforDetial.has_frozen?'冻结':'正常' }}</span>
    </p>
    <p class="common-item">
      <span class="label">统一社会信用编码：</span>
      <span class="value">{{ subjectInforDetial.credit_code }}</span>
    </p>
    <p class="common-item">
      <span class="label">成立日期：</span>
      <span class="value">{{ subjectInforDetial.set_up_at }}</span>
    </p>
    <p class="common-item">
      <span class="label">备注：</span>
      <span class="value">{{ subjectInforDetial.remark }}</span>
    </p>
    <div class="common-item">
      <p class="label">
        冻结与解冻记录：
      </p>
      <div
        style="display:block;margin-left:200px" 
        class="value"
      >
        <Table
          size="small"
          border
          :columns="logsFields"
          :data="subjectInforDetial.freeze_logs||[]"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { freeze_logs_fields } from './../fields'
  import { SUCCESS, WARNING } from '../../../../libs/color_util'
  export default {
    props: {
      subjectInfor:{
        type:Object,
        default:() => ({}) 
      }
    },
    data() {
      this.SUCCESS = SUCCESS
      this.WARNING = WARNING
      return {}
    },
    computed: {
      subjectInforDetial() {
        if (!this.subjectInfor) {
          return {}
        }
        return this.subjectInfor
      },
      logsFields() {
        return freeze_logs_fields
      }
    }
  }
  </script>
